export const createRatePlan = `
    mutation createRatePlan($input: CreateRatePlanInput!) {
        createRatePlan(input:$input) {
            id
            name
            billableUnit
            billableUnitId
            billablePeriod
            status
            effectiveFrom
            effectiveTo
            chargeTiers {
                lowerBand
                upperBand
                rate
            }  
            createdByUsername
            createdByUser {
              name
              givenName
              familyName
              email
            }
            created
            updated  
    }
}`;

export const updateRatePlan = `
    mutation updateRatePlan($input: UpdateRatePlanInput!) {
        updateRatePlan(input:$input){
            id
            name
            billableUnit
            billableUnitId
            billablePeriod
            status
            effectiveFrom
            effectiveTo
            chargeTiers {
                lowerBand
                upperBand
                rate
            }   
            createdByUsername
            createdByUser {
              name
              givenName
              familyName
              email
            }
            created
            updated       
        }
}`;

export const deleteRatePlan = `
    mutation deleteRatePlan($input: DeleteRatePlanInput!) {
        deleteRatePlan(input:$input) 
}`;
